export const cookies = {
    stationId: "Trace-Check-In-stationId",
    hash: "Trace-Check-In-hash",
    user: "Trace-Check-In-user",
    stations: "Trace-Check-In-stations",
    cart: "Trace-Check-In-cart",
};
